import React, { useContext } from 'react';
import RightPanelBody from './RightPanelBody';
import RightPanelSendBox from './RightPanelSendBox';
import RightPanelToolbar from './RightPanelToolbar';
import { TicketContext } from '../../../app/providers/TicketContext';
import LeftPanelHeader from '../left-panel/left-panel-contents/LeftPanelHeader';

const RightPanel = () => {
  const { events } = useContext(TicketContext);

  RightPanel.renderCount = (RightPanel.renderCount || 0) + 1;

  return (
    <div className="flex h-screen flex-col bg-white">
      {events.length > 0 && (
        <div className="sticky top-0 z-30">
          <RightPanelToolbar />
        </div>
      )}

      <div className="min-h-0 flex-1 overflow-hidden">
        <div className="panel-fade h-full w-full">
          <RightPanelBody />
        </div>
      </div>

      {events.length > 0 && (
        <div className="shrink-0 bg-transparent">
          <RightPanelSendBox />
        </div>
      )}
    </div>
  );
};

export default RightPanel;
